import initI18n from './i18n';
import { getFactoidToolSchemas } from './ai-tools/getFactoidToolSchemas';

export default function init() {
  initI18n();
  // Warm the memoized factoid tool schemas after vocabulary seeding (seed-if-empty inside).
  getFactoidToolSchemas();
}
